export class DocumentService {
	async toBase64(file: File) {
		const base64 = await new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		});

		const search = ";base64,";
		return base64.substr(base64.indexOf(search) + search.length);
	}
}
